import { CanvasItem, TemplateData } from "@emisgroup/clint-templates-common";
import { isCanvasItemDirty } from "./componentUtils";

export function getAlwaysVisibleComponents(items: CanvasItem[], templateData: TemplateData): CanvasItem[] {
    return items.filter(
        item => typeof item.rule === "undefined" || item.rule === null || isCanvasItemDirty(item, templateData),
    );
}
